// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".email-field .ui-form-field{margin-bottom:0}.email-field .communication_preferences{display:flex}.email-field .communication_preferences__label-spacer{flex:0 0 30%;margin-right:10px}", ""]);
// Exports
module.exports = exports;
